export default "__VITE_ASSET__CXK_y425__"